function Analysis() {
  return (
    <div>
      <div
        className="chartBox chartOptions flex-column"
        style={{ alignItems: "flex-start", gap: "16px" }}
      >
        <h2 class="grafanaTitle">Workforce Demand What-if Analysis</h2>
        <p>
          This module provides the tools and documentation necessary to simulate
          and assess the impact of a pandemic on workforce demand across
          economic sectors. By downloading the provided template Excel file, you
          can input pandemic-related data and workforce distributions to
          evaluate potential short- and long-term effects on personnel
          availability.
        </p>

        <span>To get started:</span>
        <ul>
          <li>
            Download the{" "}
            <a
              href="https://docs.google.com/spreadsheets/d/1I5VOsDYvup46r8ybvWf98nLb8RYtjOE9/edit?usp=sharing&ouid=116271658120905833828&rtpof=true&sd=true"
              target="_blank"
              rel="noreferrer"
            >
              empty Excel template to input your own data.
            </a>
          </li>
          <li>
            Download the{" "}
            <a
              href="https://docs.google.com/spreadsheets/d/1kXRUGw6AY9oU8-BKoG6NYYDgAzaX49ho/edit?usp=sharing&ouid=116271658120905833828&rtpof=true&sd=true"
              target="_blank"
              rel="noreferrer"
            >
              example-filled Excel file
            </a>{" "}
            to see how real-world data (e.g., COVID-19) was used.
          </li>
          <li>
            Download the{" "}
            <a
              href="https://drive.google.com/file/d/1HaT2B4KJmx5Q70_N_CzcVmEgd48iRon8/view?usp=sharing"
              target="_blank"
              rel="noreferrer"
            >
              User Guide (PDF)
            </a>{" "}
            for step-by-step instructions and explanations of the model's
            functionality.
          </li>
        </ul>

        <p>
          The model supports scenario-based analysis (e.g., best case, worst
          case) and highlights how positive cases, hospitalizations, and deaths
          impact workforce needs. Whether you're analyzing national sectors or a
          specific company, this tool helps you anticipate risks and support
          strategic workforce planning in crisis conditions.
        </p>
      </div>
    </div>
  );
}

export default Analysis;
